import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import { Button, Alert } from "reactstrap";
import {
  Container,
  Form,
  Row,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from "reactstrap";
import { WHO_AM_I_STATE } from "../../../types-business/Profile";
import constants from "../../../utils/constants";
import { parse as parseQueryParams } from "query-string";
import * as sessionActions from "../../actions/session";

interface Props {
  loginSSP: (session: string, ssp?: object) => any;
  login: (session: string) => any;
  whoami: () => any;
  ssp: Array<{ userName: string; id: number }>;
  loginUser: boolean;
  loginUserError: any;
  history: any;
  successfullLogin: boolean;
  iKnowWhoIAm: WHO_AM_I_STATE;
  logoutUser: () => any;
  securitySpacesError: any;
  gettingSecuritySpaces: boolean;
  successfullSecuritySpaces: boolean;
}

interface State {
  dropdownOpen: boolean;
  selectedSSP: object;
  loginEnded: boolean;
}

class Home extends React.Component<Props, State> {
  state = {
    dropdownOpen: false,
    selectedSSP: null,
    errors: {},
    loginEnded: false
  };

  onSubmit = e => {
    e.preventDefault();

    const queryParam = parseQueryParams(this.props.location.search);
    this.props.loginSSP(queryParam.session, this.state.selectedSSP);
  };

  toggle = () => {
    this.setState(state => ({ dropdownOpen: !state.dropdownOpen }));
  };

  selectSecureSpace = option => {
    this.setState(() => ({ selectedSSP: option }));
  };

  componentDidMount() {
    const queryParam = parseQueryParams(this.props.location.search);

    if (queryParam.error) {
    } else if (queryParam.session) {
      this.props.login(queryParam.session);
    } else {
      sessionActions
        .isAlive()
        .then(() => this.props.history.push("/inicio"))
        .catch(
          () => (window.location.href = `${constants.BASE_URL}/api/auth/okta`)
        );
    }
  }

  componentDidUpdate() {
    if (
      !this.state.selectedSSP &&
      this.props.ssp &&
      this.props.ssp.length <= 1 &&
      !this.props.loginUserError
    ) {
      let selectedSSP = { id: -1, userName: "" };
      if (this.props.ssp.length === 1) {
        selectedSSP = this.props.ssp[0];
      }
      const queryParam = parseQueryParams(this.props.location.search);
      this.props.loginSSP(queryParam.session, selectedSSP);
    }

    if (
      this.props.successfullLogin ||
      this.props.iKnowWhoIAm === WHO_AM_I_STATE.SUCCESS
    ) {
      this.props.history.push("/inicio");
    }
  }

  disableForm = () => !!this.props.ssp;

  render() {
    const dropdownOptions = options => {
      return options.map(option => (
        <DropdownItem
          onClick={() => this.selectSecureSpace(option)}
          key={option.id}
        >
          {option.name}
        </DropdownItem>
      ));
    };

    return (
      <Container>
        {this.props.ssp && this.props.ssp.length > 1 && (
          <>
            <Row
              className={["justify-content-md-center", s.marginTop].join(" ")}
            >
              <Form className={["col-xs-12 col-md-4", s.form].join(" ")}>
                <p className={s.title}>Seleccione un club</p>

                <Dropdown
                  className={s.formGroup}
                  isOpen={this.state.dropdownOpen}
                  toggle={this.toggle}
                >
                  <DropdownToggle className="w-100" caret>
                    {this.state.selectedSSP
                      ? this.state.selectedSSP.name
                      : "Seleccione un Club"}
                  </DropdownToggle>
                  <DropdownMenu className="w-100">
                    {dropdownOptions(this.props.ssp)}
                  </DropdownMenu>
                </Dropdown>
                <div className={s.formGroup}>
                  <Button
                    className={s.primaryButton}
                    onClick={this.onSubmit}
                    size="lg"
                    disabled={
                      this.props.gettingSecuritySpaces || this.props.loginUser
                    }
                    block
                    type="submit"
                  >
                    {this.props.loginUser ? "Validando" : "Iniciar Sesión"}
                  </Button>
                </div>
                {(this.props.loginUserError ||
                  this.props.securitySpacesError) && (
                  <span>
                    <hr />
                    <Alert color="danger">
                      {(this.props.loginUserError &&
                        this.props.loginUserError.error_description) ||
                        (this.props.securitySpacesError &&
                          this.props.securitySpacesError.error_description)}
                    </Alert>
                  </span>
                )}
              </Form>
            </Row>
          </>
        )}
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(Home));
